<template lang="html">

    <div class="more-actions">
        <!-- create the menu on single aside -->
        <v-menu offset-y>
            <v-btn icon slot="activator" dark class="unfocus">
                <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list>
                <!-- actions are given as props, when this components is called -->
                <v-list-tile v-for="(action, index) in actions" :key="index" @click="action.callback" class="li" v-if="(action.level && action.level <= $store.state.auth.user.level) || !action.level">
                    <v-list-tile-title>{{ action.text }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
    </div>


</template>

<script>
    export default {

        props: {
            actions: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
            }
        }
    }
</script>

<style lang="stylus">

    .more-actions {
        .menu {
            float:right;
            margin:0;
            transform: translate(-10px, 8px);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/single/MoreActions.vue